<template>
  <GestionReservas />
</template>
<script>
import GestionReservas from "./components/GestionReservas";
export default {
  name: "Reservas",
  components: { GestionReservas }
};
</script>